function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256,56c-80.4,0-137.6,65.3-137.5,137.7c0,34.6,12.9,66.1,34,90.3c20,22.9,39.3,60.1,41,72l0,58.7c0,2.5,0.7,4.9,2.1,6.9 l19.1,28.8c2.3,3.5,6.2,5.6,10.4,5.6h61.6c4.2,0,8.1-2.1,10.4-5.6l19.1-28.8c1.4-2,2.1-4.5,2.1-6.9l0.1-58.7 c1.8-12.3,21.1-49.4,41-72c21.2-24.2,34-55.8,34-90.5C393.5,117.6,331.9,56,256,56z M293.5,410.9L280.1,431h-48.2l-13.4-20.1l0-4.9 h74.9L293.5,410.9L293.5,410.9z M293.5,381h-75l-0.1-25h75.1L293.5,381z M340.7,267.5c-10.9,12.5-28.4,37.6-39.5,63.5h-90.3 c-11.1-26-28.6-51.1-39.5-63.5c-18.1-20.6-27.7-46.7-27.8-74C143.4,133.4,190.7,81,256,81c62,0,112.5,50.5,112.5,112.5 C368.5,220.7,358.6,247,340.7,267.5z M256,106c-48.2,0-87.5,39.3-87.5,87.5c0,6.9,5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5 c0-34.5,28-62.5,62.5-62.5c6.9,0,12.5-5.6,12.5-12.5S262.9,106,256,106z"
});

function SvgInterestingInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestingInactive);
export default __webpack_public_path__ + "static/media/interestingInactive.ff6741a6.svg";
export { ForwardRef as ReactComponent };